/* I Listini di Aleandro dentro il gestionale (c35): i conti e i controlli della pagina.
   La lista arriva dall'app di Aleandro, nell'iframe, con un messaggio. Il totale che si vede nel dialogo è solo
   un riepilogo: quello che resta nel PDF lo rifà il server dalle voci (backend/listini.py, `totali`). */

/** Come `Math.round` dell'app di Aleandro e del server: l'euro intero, la metà verso l'alto. */
const intero = (n) => Math.floor(n + 0.5);

/** Voci e totali di una lista, con la regola dell'app: riga = quantità × (prezzo + Σ accessorio.prezzo × quantità). */
export function riepilogoLista(lista) {
  const righe = lista?.righe || [];
  const t = righe.reduce(
    (s, r) => s + r.quantita * (r.prezzo_unitario + (r.accessori || []).reduce((a, x) => a + x.prezzo_unitario * x.quantita, 0)),
    0,
  );
  return { voci: righe.length, listino: intero(t), conIva: intero(t * 1.22) };
}

/** Una lista dall'iframe, se il messaggio è davvero suo: stessa origine del biglietto, stessa finestra, forma attesa. */
export function listaDaMessaggio(ev, finestra, origine) {
  if (!finestra || ev.source !== finestra || ev.origin !== origine) return null;
  const d = ev.data;
  if (!d || d.tipo !== "ida-lista" || d.versione !== 1 || !Array.isArray(d.lista?.righe) || !d.lista.righe.length) return null;
  return d.lista;
}

/** Il messaggio «accesso scaduto» dell'iframe (anche dalla pagina 401, che non conosce l'origine: ammesso solo da lì). */
export function eScaduto(ev, finestra) {
  return Boolean(finestra) && ev.source === finestra && ev.data?.tipo === "ida-scaduto";
}

/** Da questi indirizzi i listini non si aprono: il cookie dell'iframe verrebbe da un sito terzo e il browser lo blocca. */
export const eAnteprima = (hostname) => /\.pages\.dev$/.test(hostname || "");

/* Chiudere i listini quando la persona esce dal gestionale. Il cookie dei listini sta sull'altra origine (proposte.): se
   restasse, chi usa il browser dopo aprirebbe i listini col ruolo di prima. L'origine si ricorda quando si apre la pagina
   (viene dal biglietto) in `localStorage`, così la ritrova qualunque scheda del gestionale faccia il logout, e `esci` è una richiesta semplice: il browser toglie il cookie anche se la risposta non si legge. */
const CHIAVE_ORIGINE = "ida_listini_origine";

export function ricordaOrigineListini(origine) {
  try {
    localStorage.setItem(CHIAVE_ORIGINE, origine);
  } catch {
    /* senza storage non si ricorda: il cookie scade da solo in 30 minuti */
  }
}

export function chiudiListini() {
  try {
    const origine = localStorage.getItem(CHIAVE_ORIGINE);
    if (origine) fetch(`${origine}/listini/esci`, { credentials: "include", mode: "no-cors", keepalive: true }).catch(() => {});
    localStorage.removeItem(CHIAVE_ORIGINE);
  } catch {
    /* niente da chiudere */
  }
}
